import { SupplierState, SuppliersFilterInput, useGetPaginatedFilteredSuppliersQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';

import { suppliersColumns, type SupplierRow } from '../constants/suppliersColumns';

export const SuppliersList = () => {
    // Les archivés restent hors de la liste par défaut, mais c'est désormais un filtre comme un autre :
    // visible dans la barre, effaçable, et partageable par l'URL.
    const defaultFilters: SuppliersFilterInput = {
        state: [SupplierState.Regular],
    };

    const {
        loading: suppliersLoading,
        data: suppliersData,
        error: suppliersError,
        refetch,
        fetchMore,
    } = useGetPaginatedFilteredSuppliersQuery({
        variables: { filters: defaultFilters },
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    if (suppliersError) {
        throw new Error('Une erreur est survenue lors de la récupération des fournisseurs');
    }

    const hasMore = suppliersData?.paginatedFilteredSuppliers.hasMore ?? false;
    const suppliers = suppliersData?.paginatedFilteredSuppliers.suppliers ?? [];

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<SupplierRow, SuppliersFilterInput>
                columns={suppliersColumns}
                data={suppliers}
                filterMode="server"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/supplier/${row._id}`}
                hasMore={hasMore}
                isLoading={suppliersLoading}
                refetch={async (vars) => {
                    await refetch({ ...vars });
                }}
                fetchMore={async (opts) => {
                    await fetchMore({ variables: opts.variables });
                }}
                defaultFilters={defaultFilters}
                searchPlaceholder="Nom, ID totadmin ou ID Odoo du fournisseur"
                searchFilterKey="searchValue"
            />
        </div>
    );
};
